<div class="target-note-thread">
  <div class="target-note-thread-actions" *ngIf="hasMore">
    <button
      pButton
      type="button"
      class="p-button-text"
      icon="pi pi-chevron-up"
      [disabled]="isLoading"
      (click)="loadEarlierMessages()"
    >
      &nbsp;Load earlier messages
    </button>
  </div>

  <div #messageList class="target-note-thread-list" [class.is-loading]="isLoading">
    <div *ngIf="!isLoading && messages.length === 0" class="target-note-empty">
      No notes available
    </div>

    <div
      *ngFor="let message of messages; trackBy: trackByMessage"
      class="target-note-message-row"
      [class.is-current-user]="message.IsCurrentUser"
    >
      <div class="target-note-message" [ngClass]="messageClass(message)">
        <div class="target-note-message-meta">
          <span>{{ message.CreatedByUserFullName || 'Unknown user' }}</span>
          <span *ngIf="message.CreatedDate">
            {{ message.CreatedDate | date : "MM/dd/yyyy hh:mm a" }}
          </span>
        </div>
        <div class="target-note-message-text">{{ message.Message }}</div>
        <div class="target-note-message-status" *ngIf="statusText(message)">
          {{ statusText(message) }}
        </div>
      </div>
    </div>
  </div>

  <div class="target-note-composer" *ngIf="!readOnly">
    <textarea
      pTextarea
      rows="2"
      [(ngModel)]="newMessage"
      [disabled]="isSending"
      (keydown.control.enter)="sendMessage()"
    ></textarea>
    <button
      pButton
      type="button"
      icon="pi pi-send"
      [disabled]="isSending || !newMessage.trim()"
      (click)="sendMessage()"
    ></button>
  </div>
</div>
